module.exports = __webpack_public_path__ + "img/sam-icons.391350c.svg";